const is_active = (context, conditional) => {
  if (conditional) {
    context.$store.commit('set_navigation_next', {
      custom: 'button-disabled'
    })
  } else {
    context.$store.commit('set_navigation_next', {
      custom: ''
    })
  }
}

export {is_active}


// WEBPACK FOOTER //
// ./src/utils/is_active.js